import script from "./MollyProductDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./MollyProductDetail.vue?vue&type=script&setup=true&lang=ts"

import "./MollyProductDetail.vue?vue&type=style&index=0&id=1ac21662&lang=css"

const __exports__ = script;

export default __exports__